// extracted by mini-css-extract-plugin
export default {"skills":"Skill_skills__dECTF","box":"Skill_box__tz5wi","mainbox":"Skill_mainbox__1Dp72"};